import React from 'react'; // eslint-disable-line no-unused-vars

// /////////////////////////////////////////////////////////////////////////////////////////////////
const userOrganizationState = {
  entityId: '',
  parentOrgId: '',
  entityName: '',
  entityType: '',
  email: '',
  phoneNumber: '',
};

const userOrganization = (state = userOrganizationState, action) => {
  const { type, ...rest } = action;
  var state1;
  switch (type) {
    case 'userOrganization/update':
      state1 = { ...state, ...rest };
      return state1;

    // Other
    case 'userTkn/update':
      state1 = { ...state, ...action.organization };
      return state1;
    default:
      return state;
  }
};

export default userOrganization;
